import request from '@/config';

enum Apis {
	AuditUserList = `/api/contractdraft/getaudituserlist`,
	PayplanList = `/api/contractdraft/getpayplanlist`,
	MaterialList = `/api/contractdraft/getmateriallist`,
	DraftEditors = `/api/contractdraft/draftcontracteditors`,
	Submit = `/api/contractdraft/submitcontract`,
	PlanDetail = `/api/contractdraft/getpayplandetail`,
  ContentRecognition = `/api/contractdraft/ContentRecognition`,  //识别
  ContentReview = '/api/contractdraft/ContentReview'             //评审
}

/* 提交合同到OA审批 */
export const GetPayplanDetailApi = (planId: string): Promise<IResponse> => request.post({ url: Apis.PlanDetail, data: { id: planId } });

/* 提交合同到OA审批 */
export const ContractSubmitApi = (contract: any): Promise<IResponse> => request.post({ url: Apis.Submit, data: { id: contract.id, revision: contract.revision } });

/* 创建/编辑合同草稿 */
export const ContractDraftEditorsApi = (contract: any): Promise<IResponse> => request.post({ url: Apis.DraftEditors, data: contract });

/* 获取某个合同审批人员数据列表 */
export const GetAuditUserListApi = (contractId: string): Promise<IResponse> => request.post({ url: Apis.AuditUserList, data: { contract_id: contractId } });

/* 获取某个合同付款计划数据列表 */
export const GetPayplanListApi = (contractId: string): Promise<IResponse> => request.post({ url: Apis.PayplanList, data: { contract_id: contractId } });

/* 获取某个合同附件数据列表 */
export const GetMaterialListApi = (contractId: string): Promise<IResponse> => request.post({ url: Apis.MaterialList, data: { id: contractId } });

//export const ContentRecognition = (fileData: any): Promise<IResponse> => request.post({ url: Apis.ContentRecognition, data: fileData });
export function ContentRecognition(formData: any): Promise<IResponse> {
  return request.post({
    url: Apis.ContentRecognition,
    data: formData
  });
}

export function ContentReview(formData: any): Promise<IResponse> {
  return request.post({
    url: Apis.ContentReview,
    data: formData,
  });
}

